import { cpfMask } from "utils/cpf";
import { ICarteirinha } from "./types";

export type CarteirinhaColumn = {
  field: keyof ICarteirinha;
  header: string;
  width: number;
  // Colunas de status viram <Chip> na tabela; no CSV saem como texto puro.
  isStatus?: boolean;
  format: (row: ICarteirinha) => string;
};

const text = (value: string | null) => value || "-";

// vigencyStart chega como "YYYY-MM-DD". Reformatar por split evita que o
// timezone empurre a data para o dia anterior, como `new Date` faria.
const formatVigency = (value: string | null) => {
  if (!value) return "-";
  const [y, m, d] = value.split("-");
  return d && m && y ? `${d}/${m}/${y}` : value;
};

const formatPrice = (value: number | null) =>
  value == null
    ? "-"
    : Number(value).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const CARTEIRINHA_COLUMNS: CarteirinhaColumn[] = [
  { field: "cpf", header: "CPF", width: 130, format: (r) => (r.cpf ? cpfMask(r.cpf) : "-") },
  // CPF do titular — ao lado do CPF; ordenar por ele agrupa a familia
  // (titular + dependentes).
  { field: "cpfTitular", header: "CPF Titular", width: 130, format: (r) => (r.cpfTitular ? cpfMask(r.cpfTitular) : "-") },
  { field: "fullName", header: "Nome", width: 220, format: (r) => text(r.fullName) },
  { field: "cardNumber", header: "Carteirinha", width: 180, format: (r) => text(r.cardNumber) },
  { field: "kinship", header: "Parentesco", width: 120, format: (r) => text(r.kinship) },
  { field: "operatorName", header: "Operadora", width: 200, format: (r) => text(r.operatorName) },
  { field: "planName", header: "Plano", width: 200, format: (r) => text(r.planName) },
  { field: "planPrice", header: "Valor", width: 110, format: (r) => formatPrice(r.planPrice) },
  { field: "contractCode", header: "Cód. Contrato", width: 130, format: (r) => text(r.contractCode) },
  { field: "vigencyStart", header: "Vigência", width: 120, format: (r) => formatVigency(r.vigencyStart) },
  // StatusBeneficiario — status do colaborador/pessoa na operadora.
  { field: "beneficiaryStatus", header: "Status Colaborador", width: 160, isStatus: true, format: (r) => text(r.beneficiaryStatus) },
  // StatusBeneficiarioOperadora — status da operadora/contrato.
  { field: "operatorBeneficiaryStatus", header: "Status Operadora", width: 160, isStatus: true, format: (r) => text(r.operatorBeneficiaryStatus) },
];
